import React, { Component } from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  Avatar,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Stack,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import {
  PointOfSale,
  Print,
  QrCodeScanner,
  Scale,
  ReceiptLong,
  WifiOff,
  Sync,
  Bolt,
  ExpandMore,
  CheckCircle,
  ArrowForward,
  Computer,
  Paid,
  Store,
  Speed,
  ShieldCheck
} from '@mui/icons-material';

class FazPedidoModuloPDVPage extends Component {
  render() {
    return (
      <Box sx={{ bgcolor: '#ffffff', color: '#0f172a', minHeight: '100vh', pb: 10 }}>

        {/* 1. HERO SECTION */}
        <Box
          sx={{
            bgcolor: '#ffffff',
            pt: { xs: 8, md: 12 },
            pb: { xs: 8, md: 10 },
            borderBottom: '1px solid #f1f5f9'
          }}
        >
          <Container maxWidth="lg">
            <Grid container spacing={4} alignItems="center">
              <Grid size={{ xs: 12, md: 7 }}>
                <Chip
                  label="Tecnologia FazPedido"
                  sx={{
                    bgcolor: 'rgba(124, 58, 237, 0.1)',
                    color: '#7c3aed',
                    fontWeight: 700,
                    mb: 2,
                    px: 1
                  }}
                />
                <Typography
                  variant="h2"
                  component="h1"
                  sx={{
                    fontWeight: 800,
                    fontSize: { xs: '2.2rem', md: '3.4rem' },
                    lineHeight: 1.2,
                    color: '#0f172a',
                    mb: 2
                  }}
                >
                  Frente de Caixa (PDV){' '}
                  <Box component="span" sx={{ color: '#7c3aed' }}>
                    ultra rápido e ágil
                  </Box>
                </Typography>
                <Typography
                  variant="h6"
                  sx={{ color: '#64748b', fontWeight: 400, mb: 4, lineHeight: 1.6 }}
                >
                  Elimine filas no balcão e gerencie suas vendas presenciais com facilidade. Suporte a impressoras térmicas, balanças, leitores de código de barras e emissão fiscal com total integração online e offline.
                </Typography>

                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <Button
                    variant="contained"
                    size="large"
                    endIcon={<ArrowForward />}
                    sx={{
                      bgcolor: '#7c3aed',
                      '&:hover': { bgcolor: '#6d28d9' },
                      px: 4,
                      py: 1.8,
                      fontSize: '1.1rem',
                      fontWeight: 700,
                      borderRadius: '12px',
                      textTransform: 'none',
                      boxShadow: '0 10px 25px -5px rgba(124, 58, 237, 0.3)'
                    }}
                  >
                    Testar PDV FazPedido Grátis
                  </Button>
                  <Button
                    variant="outlined"
                    size="large"
                    sx={{
                      color: '#7c3aed',
                      borderColor: '#7c3aed',
                      '&:hover': { borderColor: '#6d28d9', bgcolor: 'rgba(124, 58, 237, 0.04)' },
                      px: 3,
                      py: 1.8,
                      borderRadius: '12px',
                      textTransform: 'none',
                      fontWeight: 700
                    }}
                  >
                    Ver Demonstração ao Vivo
                  </Button>
                </Stack>
              </Grid>

              {/* MOCKUP VISUAL PDV */}
              <Grid size={{ xs: 12, md: 5 }}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 4,
                    bgcolor: '#f8fafc',
                    borderRadius: '24px',
                    border: '2px solid #7c3aed',
                    boxShadow: '0 20px 30px -10px rgba(124, 58, 237, 0.15)'
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <Avatar sx={{ bgcolor: '#7c3aed', mr: 2, width: 48, height: 48 }}>
                      <PointOfSale />
                    </Avatar>
                    <Box>
                      <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a' }}>
                        Terminal PDV Operacional
                      </Typography>
                      <Typography variant="caption" sx={{ color: '#64748b' }}>
                        Caixa #01 • Operador: Loja Principal
                      </Typography>
                    </Box>
                  </Box>

                  <Card variant="outlined" sx={{ mb: 2, borderRadius: '14px', borderColor: '#e2e8f0' }}>
                    <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                      <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                          Venda Direta #8841
                        </Typography>
                        <Chip label="Caixa Aberto" size="small" sx={{ bgcolor: 'rgba(124, 58, 237, 0.15)', color: '#7c3aed', fontWeight: 700 }} />
                      </Stack>
                      <Typography variant="h6" sx={{ color: '#7c3aed', fontWeight: 800, mt: 1 }}>
                        R$ 45,50
                      </Typography>
                      <Typography variant="caption" sx={{ color: '#64748b' }}>
                        Debito / PIX Maquininha • Impresso em 80mm
                      </Typography>
                    </CardContent>
                  </Card>

                  <Box sx={{ bgcolor: '#ffffff', p: 2, borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <CheckCircle sx={{ color: '#7c3aed', fontSize: 20 }} />
                      <Typography variant="body2" sx={{ fontWeight: 600, color: '#334155' }}>
                        Sincronização em tempo real com pedidos online e estoque.
                      </Typography>
                    </Stack>
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </Box>

        {/* 2. OS 4 PILARES DO PDV */}
        <Container maxWidth="lg" sx={{ mt: 10 }}>
          <Grid container spacing={3}>
            {[
              {
                num: '01',
                title: 'Impressão Térmica ESC/POS',
                desc: 'Disparo direto para impressoras de 58mm e 80mm via USB, Bluetooth ou Rede sem depender de drivers lentos.',
                icon: <Print sx={{ color: '#7c3aed', fontSize: 32 }} />
              },
              {
                num: '02',
                title: 'Integração com Balança & Leitor',
                desc: 'Pesagem rápida na caixa e leitura de código de barras para comércios, hortifrutis e balcões.',
                icon: <Scale sx={{ color: '#7c3aed', fontSize: 32 }} />
              },
              {
                num: '03',
                title: 'Atendimento Express',
                desc: 'Lançamento de itens com poucos cliques, atalhos de teclado e interface rápida otimizada para toque.',
                icon: <Speed sx={{ color: '#7c3aed', fontSize: 32 }} />
              },
              {
                num: '04',
                title: 'Emissão Fiscal Simplificada',
                desc: 'Pronto para emissão de NFC-e / NF-e com comunicação rápida e sem burocracia.',
                icon: <ReceiptLong sx={{ color: '#7c3aed', fontSize: 32 }} />
              }
            ].map((pillar, idx) => (
              <Grid size={{ xs: 12, sm: 6, md: 3 }} key={idx}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    height: '100%',
                    borderRadius: '16px',
                    bgcolor: '#f8fafc',
                    border: '1px solid #e2e8f0',
                    position: 'relative',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      borderColor: '#7c3aed',
                      transform: 'translateY(-4px)',
                      boxShadow: '0 12px 20px -5px rgba(124, 58, 237, 0.1)'
                    }
                  }}
                >
                  <Typography variant="h3" sx={{ fontWeight: 900, color: 'rgba(124, 58, 237, 0.2)', position: 'absolute', top: 16, right: 16 }}>
                    {pillar.num}
                  </Typography>
                  <Box sx={{ mb: 2 }}>{pillar.icon}</Box>
                  <Typography variant="h6" sx={{ fontWeight: 700, color: '#0f172a', mb: 1 }}>
                    {pillar.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#64748b', lineHeight: 1.6 }}>
                    {pillar.desc}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>

        {/* 3. FUNCIONALIDADES DO FRENTE DE CAIXA */}
        <Container maxWidth="lg" sx={{ mt: 12 }}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 4, md: 6 },
              borderRadius: '24px',
              bgcolor: '#f8fafc',
              border: '1px solid #e2e8f0'
            }}
          >
            <Grid container spacing={4} alignItems="center">
              <Grid size={{ xs: 12, md: 6 }}>
                <Typography variant="h4" sx={{ fontWeight: 800, color: '#0f172a', mb: 2 }}>
                  Agilidade e controle absoluto no seu balcão de atendimento
                </Typography>
                <Typography variant="body1" sx={{ color: '#475569', mb: 3 }}>
                  O PDV do FazPedido foi desenhado para quem precisa de agilidade. Evite filas no horário de pico e mantenha o caixa sempre sob controle.
                </Typography>
                <Typography variant="body2" sx={{ color: '#64748b', mb: 4 }}>
                  Gerencie sangrias, suprimentos, múltiplos meios de pagamento e fechamento de caixa detalhado em poucos passos.
                </Typography>

                <Grid container spacing={2}>
                  {[
                    { title: 'Controle de Caixa', desc: 'Abertura, sangria, suprimento e fechamento cego com relatório completo.', icon: <Paid /> },
                    { title: 'Multi-dispositivos', desc: 'Funciona em computadores, tablets ou maquininhas inteligentes.', icon: <Computer /> },
                    { title: 'Impressão Automática', desc: 'Disparo direto para a cozinha e via de atendimento do cliente.', icon: <Print /> },
                    { title: 'Operação Resiliente', desc: 'Navegação fluida que evita interrupções no momento da venda.', icon: <Bolt /> }
                  ].map((item, i) => (
                    <Grid size={{ xs: 12, sm: 6 }} key={i}>
                      <Stack direction="row" spacing={1.5} alignItems="flex-start">
                        <Avatar sx={{ bgcolor: '#7c3aed', width: 36, height: 36, mt: 0.5 }}>
                          {React.cloneElement(item.icon, { sx: { fontSize: 20, color: '#fff' } })}
                        </Avatar>
                        <Box>
                          <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#0f172a' }}>
                            {item.title}
                          </Typography>
                          <Typography variant="caption" sx={{ color: '#64748b', display: 'block', lineHeight: 1.4 }}>
                            {item.desc}
                          </Typography>
                        </Box>
                      </Stack>
                    </Grid>
                  ))}
                </Grid>
              </Grid>

              <Grid size={{ xs: 12, md: 6 }}>
                <Box
                  sx={{
                    bgcolor: '#ffffff',
                    p: 4,
                    borderRadius: '20px',
                    border: '2px solid #7c3aed',
                    boxShadow: '0 15px 30px -10px rgba(124, 58, 237, 0.12)'
                  }}
                >
                  <Typography variant="h5" sx={{ fontWeight: 800, color: '#7c3aed', mb: 2 }}>
                    Recursos Inclusos no PDV
                  </Typography>
                  <List disablePadding>
                    <ListItem sx={{ px: 0 }}>
                      <ListItemIcon><CheckCircle sx={{ color: '#7c3aed' }} /></ListItemIcon>
                      <ListItemText primary="Divisão de pagamento (dinheiro, PIX, cartões e fiado)" />
                    </ListItem>
                    <ListItem sx={{ px: 0 }}>
                      <ListItemIcon><CheckCircle sx={{ color: '#7c3aed' }} /></ListItemIcon>
                      <ListItemText primary="Identificação de cliente para programas de fidelidade" />
                    </ListItem>
                    <ListItem sx={{ px: 0 }}>
                      <ListItemIcon><CheckCircle sx={{ color: '#7c3aed' }} /></ListItemIcon>
                      <ListItemText primary="Comandos de atalho rápido no teclado para vendas ágeis" />
                    </ListItem>
                    <ListItem sx={{ px: 0 }}>
                      <ListItemIcon><CheckCircle sx={{ color: '#7c3aed' }} /></ListItemIcon>
                      <ListItemText primary="Integração total com catálogo digital e estoque unificado" />
                    </ListItem>
                  </List>
                </Box>
              </Grid>
            </Grid>
          </Paper>
        </Container>

        {/* 4. CONEXÃO COM IMPRESSORAS E HARDWARE */}
        <Container maxWidth="lg" sx={{ mt: 10 }}>
          <Grid container spacing={4} alignItems="center">
            <Grid size={{ xs: 12, md: 6 }}>
              <Paper
                elevation={0}
                sx={{
                  p: 4,
                  bgcolor: '#7c3aed',
                  color: '#ffffff',
                  borderRadius: '24px',
                  boxShadow: '0 20px 40px -10px rgba(124, 58, 237, 0.4)'
                }}
              >
                <Print sx={{ fontSize: 60, mb: 2 }} />
                <Typography variant="h4" sx={{ fontWeight: 800, mb: 2 }}>
                  Impressão Direta sem Fila
                </Typography>
                <Typography variant="body1" sx={{ opacity: 0.9, mb: 3 }}>
                  Conecte impressoras térmicas via USB, Bluetooth ou IP em portas locais. Envio direto de comandos ESC/POS sem depender do diálogo padrão do navegador.
                </Typography>
                <Chip label="Suporte a 58mm e 80mm" sx={{ bgcolor: '#ffffff', color: '#7c3aed', fontWeight: 700 }} />
              </Paper>
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h4" sx={{ fontWeight: 800, color: '#0f172a', mb: 2 }}>
                Compatível com os equipamentos que você já possui
              </Typography>
              <Typography variant="body1" sx={{ color: '#475569', mb: 3 }}>
                Não é preciso trocar seus equipamentos atuais para usar o FazPedido. O sistema foi desenvolvido para ser leve e compatível com as principais marcas do mercado.
              </Typography>

              <Stack spacing={2}>
                {[
                  { title: 'Impressoras Térmicas', desc: 'Compatibilidade nativa com Daruma, Bematech, Elgin, Bematech, Epson e modelos genéricos ESC/POS.' },
                  { title: 'Leitores de Código de Barras', desc: 'Bipou, leu! Cadastro e busca automática de itens no caixa.' },
                  { title: 'Balanças de Balcão', desc: 'Leitura direta do peso para venda por quilo ou etiquetadoras de balança.' },
                  { title: 'Gavetas de Dinheiro', desc: 'Abertura automática de gaveta com acionamento na finalização da venda.' }
                ].map((hardware, idx) => (
                  <Paper key={idx} elevation={0} sx={{ p: 2, bgcolor: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#7c3aed' }}>
                      {hardware.title}
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#64748b' }}>
                      {hardware.desc}
                    </Typography>
                  </Paper>
                ))}
              </Stack>
            </Grid>
          </Grid>
        </Container>

        {/* 5. FAQ / PERGUNTAS FREQUENTES */}
        <Container maxWidth="md" sx={{ mt: 10 }}>
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography variant="overline" sx={{ color: '#7c3aed', fontWeight: 800, letterSpacing: 1.5 }}>
              DÚVIDAS FREQUENTES
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: 800, color: '#0f172a' }}>
              Perguntas sobre o Módulo PDV
            </Typography>
          </Box>

          {[
            {
              q: '1. O PDV precisa de internet para funcionar?',
              a: 'O PDV sincroniza dados na nuvem em tempo real, mas possui mecanismos de contingência local para que a sua operação de caixa não pare mesmo com instabilidades na conexão.'
            },
            {
              q: '2. Preciso instalar algum programa pesado no meu computador?',
              a: 'Não! O PDV do FazPedido é moderno e roda direto no navegador de forma extremamente leve, conectando-se aos periféricos locais.'
            },
            {
              q: '3. Consigo usar o PDV em mais de um caixa ao mesmo tempo?',
              a: 'Sim. Você pode abrir múltiplos terminais de caixa simultaneamente, com controle individual de operador e fechamentos separados.'
            },
            {
              q: '4. Os pedidos do Cardápio Digital entram no PDV?',
              a: 'Sim! Os pedidos feitos pelos seus clientes no delivery, mesa ou balcão caem diretamente no painel do PDV para confirmação e impressão automática.'
            }
          ].map((faq, fIdx) => (
            <Accordion
              key={fIdx}
              elevation={0}
              sx={{
                mb: 1.5,
                border: '1px solid #e2e8f0',
                borderRadius: '12px !important',
                '&:before': { display: 'none' },
                '&.Mui-expanded': { border: '1px solid #7c3aed' }
              }}
            >
              <AccordionSummary expandIcon={<ExpandMore sx={{ color: '#7c3aed' }} />}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#0f172a' }}>
                  {faq.q}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body2" sx={{ color: '#64748b', lineHeight: 1.7 }}>
                  {faq.a}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Container>

        {/* 6. BANNER FINAL DE CONVERSÃO */}
        <Container maxWidth="lg" sx={{ mt: 10 }}>
          <Paper
            elevation={0}
            sx={{
              bgcolor: '#ffffff',
              borderRadius: '28px',
              p: { xs: 5, md: 8 },
              textAlign: 'center',
              border: '3px solid #7c3aed',
              boxShadow: '0 20px 40px -15px rgba(124, 58, 237, 0.25)'
            }}
          >
            <Typography variant="h3" sx={{ fontWeight: 900, color: '#0f172a', mb: 2, fontSize: { xs: '2rem', md: '2.6rem' } }}>
              Modernize a frente de caixa do seu negócio!
            </Typography>
            <Typography variant="h6" sx={{ color: '#64748b', mb: 4, maxW: '650px', mx: 'auto', fontWeight: 400 }}>
              Experimente o PDV do FazPedido e agilize o atendimento dos seus clientes no balcão hoje mesmo.
            </Typography>
            <Button
              variant="contained"
              size="large"
              endIcon={<ArrowForward />}
              sx={{
                bgcolor: '#7c3aed',
                color: '#ffffff',
                '&:hover': { bgcolor: '#6d28d9' },
                px: 5,
                py: 2,
                fontSize: '1.2rem',
                fontWeight: 800,
                borderRadius: '14px',
                textTransform: 'none',
                boxShadow: '0 10px 25px -5px rgba(124, 58, 237, 0.4)'
              }}
            >
              Falar com um Especialista
            </Button>
          </Paper>
        </Container>

      </Box>
    );
  }
}

export default FazPedidoModuloPDVPage;